module.exports = function() {
  return new Worker(__webpack_public_path__ + "37d6c5052386ba4bd058.worker.js");
};